import currency from "currency.js";
import type { LanguageType } from "@/store/types/language";

export const formatCurrencyByLanguage = (
  value: number,
  language: LanguageType,
  includeDecimals: boolean = true,
) => {
  const precision = includeDecimals ? 2 : 0;

  switch (language) {
    case "english":
      return currency(value, {
        decimal: ".",
        separator: ",",
        precision,
      }).format();
    case "french":
      return `${currency(value, {
        decimal: ",",
        separator: " ",
        symbol: "",
        precision,
      }).format()} $`;
    default:
      return `${value}`;
  }
};
